import { Injectable, EventEmitter } from '@angular/core';
import { StorageService } from 'src/app/services/storage.service';
import { AlertService } from 'src/app/services/alert.service';
import { ArboService } from 'src/app/services/arbo.service';
import { ClientService } from 'src/app/services/client.service';
import { HttpService } from 'src/app/services/http.service';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root',
})
export class SessionService implements CanActivate {
  public menuIndex = 0;
  public user;
  public sectionId = 1;
  public membership;
  public account;
  public accounts;
  public loaded;
  public accountId; // Será mantido sincronizado com account.id
  public currentSourceId;
  
  // Adiciona um EventEmitter para notificar mudanças de conta
  public accountChanged = new EventEmitter<void>();

  private _resolve;

  constructor(
    private router: Router,
    private alertService: AlertService,
    private arboService: ArboService,
    private userService: UserService,
    private clientService: ClientService,
    private storageService: StorageService,
    private httpService: HttpService
  ) {
    this.loaded = new Promise((resolve) => {
      this._resolve = resolve;
    });
    this.loadPreviousSession();
  }

  async loadPreviousSession() {
    this.user = this.storageService.get('user');
    if (this.user && this.user.token) await this.setupSession(this.user.token);
  }

  async setupSession(token) {
    this.httpService.setKey(token.token);
    const user = await this.arboService.get('User', token.userId);
    console.log(user)
    user.token = token;
    this.accounts = user.accounts;

    // Tenta restaurar a conta selecionada do localStorage
    const selectedAccountId = localStorage.getItem('selectedAccountId');
    
    if (selectedAccountId && this.accounts) {
      // Converte para número para comparação correta
      const accountIdNum = parseInt(selectedAccountId, 10);
      
      // Procura a conta nas contas disponíveis
      this.account = this.accounts.find(acc => acc.id === accountIdNum);
      
      // Se não encontrou a conta nas disponíveis, use a primeira
      if (!this.account && this.accounts.length > 0) {
        this.account = this.accounts[0];
      }
    } else if (this.accounts && this.accounts.length > 0) {
      // Caso não tenha conta salva, use a primeira disponível
      this.account = this.accounts[0];
    }
    
    // Sincronize o accountId com o ID da conta atual
    if (this.account) {
      this.accountId = this.account.id;
      // Atualiza o localStorage para garantir consistência
      localStorage.setItem('selectedAccountId', String(this.account.id));
    }

    try {
      user.memberships = await this.clientService.getMemberships();
    } catch (e) {
      user.memberships = [];
    }
    
    this.setUser(user);
    
    try {
      this.membership = this.storageService.get('membership');
    } catch (e) {}
    
    if (this.membership) await this.selectMembership(this.membership);
    else if (user.memberships.length > 0)
      await this.selectMembership(user.memberships[0]);
    
    this._resolve(this.user);
    
    // Emite evento para notificar que a conta foi carregada
    this.accountChanged.emit();
  }

  // Método para trocar de conta
  async selectAccount(accountId) {
    if (!this.accounts) return false;
    
    const selectedAccount = this.accounts.find(acc => acc.id === accountId);
    
    if (selectedAccount) {
      this.account = selectedAccount;
      this.accountId = accountId;
      localStorage.setItem('selectedAccountId', String(accountId));
      
      // Emite evento para notificar que a conta foi alterada
      this.accountChanged.emit();
      return true;
    }
    
    return false;
  }

  async selectMembership(membership) {
    this.membership = membership;
    await this.storageService.store('membership', this.membership);
    if (membership) this.sectionId = membership.sectionId;
  }

  async selectMembershipBySectionId(sectionId) {
    await this.selectMembership(
      this.user.memberships.find((membership) => {
        return membership.sectionId == sectionId;
      })
    );
  }

  setUser(user) {
    this.user = user;
    return this.storageService.store('user', this.user);
  }

  getUser() {
    return this.user;
  }

  saveUser(data) {
    if (this.user) {
      data = Object.assign(this.user, data);
    } else {
      // TODO: remover
      data.id = 1;
    }
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(data);
      }, 1500);
    }).then((user) => {
      this.setUser(user);
      return this.user;
    });
  }

  async login(login, password) {
    this.httpService.setKey(null);
    this.setUser(null);
    const token = await this.arboService.auth(login, password);
    console.log(token)
    await this.setupSession(token);
  }

  async logout() {
    if (this.getUser()) {
      const msg = 'Até mais, ' + this.getUser().profile.nome + '!';
      this.alertService.toast(msg);
    }
  
    this.httpService.setKey(null);  
    this.setUser(null);             
    this.selectMembership(null);    
  
    // Redireciona para a página de login
    this.router.navigate(['/login']);
  }

  async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    if (state.url.substr(0, 6) == '/login') {
      if (this.getUser()) {
        this.logout();
      } 
    } else {
      if (!this.getUser()) {
        await this.router.navigate(['/login']);
        return false;
      }
    }
    return true;
  }
}